import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import MasterLeftPanel from './include/MasterLeftPanel';
import { useNavigate } from 'react-router-dom';
function CmsDashBoard() {
    let navigate = useNavigate();

    useEffect(() => {
      }, []);

  return (
    <>
        <MasterLeftPanel/>
        <main className='home-section'>
        <Header/>
        <div className="overlay"></div>
        <div className='col-12 mt-4'><h2>CMS Dashboard</h2></div>
            <div className='container-fulid'>
                <div className='row'>
                    <div className="col-md-6 col-12">
                    <div className="card h-100">
                        <div className="bg-holder bg-card"></div>
                        <div className="card-header z-1">
                        <h5 className="text-primary">CMS Pages! </h5>
                        <h6 className="text-600">Here are some quick links for you to start </h6>
                        </div>
                        <div className="card-body z-1">
                        <div className="row g-2">
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/22">
                                        <h6 className="mb-0">About Us</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/25">
                                        <h6 className="mb-0">Air Freight</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/14">
                                        <h6 className="mb-0">Fuel Surcharge</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/2">
                                        <h6 className="mb-0">Privacy Policy</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/16">
                                        <h6 className="mb-0">Restricted & Banned Items</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/27">
                                        <h6 className="mb-0">Sea Freight</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/26">
                                        <h6 className="mb-0">Surface Freight</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/1">
                                        <h6 className="mb-0">Term & Conditions</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-message-alt-detail'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/CmsEdit/15">
                                        <h6 className="mb-0">Volumetric Weight</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div className="col-md-6 col-12">
                    <div className="card h-100">
                        <div className="bg-holder bg-card"></div>
                        <div className="card-header z-1">
                        <h5 className="text-primary">Home Pages! </h5>
                        <h6 className="text-600">Here are some quick links for you to start </h6>
                        </div>
                        <div className="card-body z-1">
                        <div className="row g-2">
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-images'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/HomePageBannerList">
                                        <h6 className="mb-0">Home page Banner</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bxs-user-badge'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/AddReview">
                                        <h6 className="mb-0">Review Add</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bxs-user-badge'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/ReviewList">
                                        <h6 className="mb-0">Review lsit</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex position-relative">
                                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bxs-contact'></i></div>
                                    <div className="flex-1"><a className="stretched-link text-800" href="/ContactList">
                                        <h6 className="mb-0">Contact us lsit</h6>
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <Footer/>
            </main>
    </>
  );
}

export default CmsDashBoard;